class PortalModeException extends Error {}

export default PortalModeException;
